module.exports = "//static.hsappstatic.net/LoginUI/static-1.15699/img/openai-logo-black.svg"